import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import FormattedDate, {
  DATE_FORMATS,
} from "basicComponents/FormattedDate/Formatted";
import styled from "styled-components";

// content + (padding * 2) + (margin * 2)
export const HEADER_HEIGHT = 48 + 16 * 2 + 16 * 2;

export default class Header extends PureComponent {
  static propTypes = {
    date: PropTypes.oneOfType([
      PropTypes.object.isRequired,
      PropTypes.string.isRequired,
    ]),
    noMargin: PropTypes.bool,
    color: PropTypes.string,
  };

  static defaultProps = { color: "black" };

  render() {
    return (
      <Wrapper headerColor={this.props.color} noMargin={this.props.noMargin}>
        <DayName>
          <FormattedDate
            date={this.props.date}
            inputFormat={DATE_FORMATS.BUMBAL}
            format="dddd"
          />
        </DayName>
        <FullDate>
          <FormattedDate
            date={this.props.date}
            inputFormat={DATE_FORMATS.BUMBAL}
            format={DATE_FORMATS.WRITTEN_DATE}
          />
        </FullDate>
      </Wrapper>
    );
  }
}

const DayName = styled.div`
  line-height: 1rem;
  font-size: 1rem;
  color: gray;
  font-weight: bold;
`;

const FullDate = styled.div`
  color: #333333;
  line-height: 2.2rem;
  font-size: 1.8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  overflow-y: visible;
  font-weight: 700;
`;

const Wrapper = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  padding-left: ${({ theme }) => theme.padding / 2}rem;
  padding-right: ${({ theme }) => theme.padding / 2}rem;
  border-top: solid 1px ${({ headerColor }) => headerColor};
  border-bottom: solid 1px ${({ headerColor }) => headerColor};
  margin-bottom: ${({ theme, noMargin }) =>
    noMargin ? 0 : theme.margin * 2}rem;
`;
